import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { ModalRemoveContainer, ModalRenameContainer } from './modals';
import { openModalRename } from '../../actions/folders/actions';
import { FolderHeader } from '../../components/FolderHeader';
import { selectShareCollection } from '../../selectors';
import { selectIsModalRemoveOpen, selectIsModalRenameOpen, selectSelectedFolder } from '../../selectors/folders';

export function FolderHeaderContainer() {
  const dispatch = useDispatch();

  const selectedFolder = useSelector(selectSelectedFolder);
  const isModalRenameOpen = useSelector(selectIsModalRenameOpen);
  const isModalRemoveOpen = useSelector(selectIsModalRemoveOpen);
  const { enabled: isShareEnabled } = useSelector(selectShareCollection, shallowEqual);

  const handleEdit = React.useCallback(() => dispatch(openModalRename()), [dispatch]);

  return (
    <>
      <FolderHeader
        shareFolderEnabled={isShareEnabled}
        isFolder={Boolean(selectedFolder)}
        text={selectedFolder ? selectedFolder.name : 'Все объявления'}
        onEditClick={handleEdit}
      />
      {isModalRenameOpen && <ModalRenameContainer />}
      {isModalRemoveOpen && <ModalRemoveContainer />}
    </>
  );
}
